import GlobalToolbarIconButton from "@/components/Button/GlobalToolbarIconButton";
import type { MenuItem } from "@/components/Menu";
import QuickActionMenuButton from "./QuickActionMenuButton";

export type GlobalQuickActionMenuProps = {
  menuItems: MenuItem[];
  menuOpen?: boolean;
  onMenuOpenChange?: (open: boolean) => void;
  showOpenShortcutHint?: boolean;
};

export default function GlobalQuickActionMenu({
  menuItems,
  menuOpen,
  onMenuOpenChange,
  showOpenShortcutHint = false
}: GlobalQuickActionMenuProps) {
  if (menuItems.length === 0) {
    return null;
  }

  if (menuItems.length === 1) {
    return (
      <div data-testid="global-quick-action-menu">
        <GlobalToolbarIconButton
          icon="add"
          ariaLabel="Add"
          testId="create-action-button"
          onClick={menuItems[0].onClick}
        />
      </div>
    );
  }

  return (
    <div data-testid="global-quick-action-menu">
      <QuickActionMenuButton
        actions={menuItems}
        label="Add"
        menuTitle="Create New"
        testId="create-action-button"
        triggerIcon="add"
        iconOnly
        menuOpen={menuOpen}
        onMenuOpenChange={onMenuOpenChange}
        showOpenShortcutHint={showOpenShortcutHint}
      />
    </div>
  );
}
